import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'
import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { MetricTypeListComponent } from './metric-type-list/metric-type-list.component'

export const metricTypeRoutes: Route[] = [
  {
    path: 'metric-types',
    component: MetricTypeListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'metric-types/:id/edit',
    redirectTo: 'metric-types/:id',
    pathMatch: 'full'
  },
  {
    path: 'metric-types/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'MetricType',
        nameSingular: 'Metric Type',
        namePlural: 'Metric Types',
        path: 'metric-types',
        slug: 'taxonomies/metric-types',
        title: 'Metric Types'
      }),
      permission: 'readTaxonomies'
    }
  }
]
